export const SET_LOADING = 'SET_LOADING';
export const SET_FAVOURITE_PLACES = 'SET_FAVOURITE_PLACES';
export const SET_ABSTRACT_PLACES_WITH_DISTANCE = 'SET_ABSTRACT_PLACES_WITH_DISTANCE';
export const SET_RECENTLY_USED_PLACES = 'SET_RECENTLY_USED_PLACES';
